import { memo } from 'react'

import View from './ToastRegion.view'

export interface ControllerProps {}

export const Controller = memo(function ToastRegionController() {
  return <View />
})

Controller.displayName = 'ToastRegion_Controller'

export default Controller
